import React from 'react';
import './Footer.css';
import Logo from './Logo';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <Logo variant="footer" onLight />
        <div className="footer-copy">© Roonbash. Build · Market · Grow.</div>
      </div>
    </footer>
  );
}
